import { FC } from 'react';
import './styles.scss';

const McrYanFrame: FC = () => {
  const iframeSrc = 'https://shark.papipromo.com.br/';

  return <iframe src={iframeSrc} frameBorder={0} title="mcryan frame" className="mcr-yan-frame" />;
};

export default McrYanFrame;
